import { Component, Input, EventEmitter, Output } from "@angular/core";
import Utils from "../../services/utils";

// Used for type-ahead multi-select dropdowns
@Component({
  selector: "lowy-dropdown",
  templateUrl: "./dropdown.component.html",
  styleUrls: ["./dropdown.component.scss"],
})
export class DropdownComponent {
  _label: string;
  _placeholder: string;
  @Input("placeholder") placeholder: string;
  @Input("fullWidth") fullWidth: string;
  @Input()
  set label(label: string) {
    // Construct field placeholder name, ex: "Image Tag"
    this._label = label;
    if (label) {
      this._placeholder = label + " " + this.placeholder;
    } else {
      this._placeholder = this.placeholder;
    }
  }
  @Input("forceActive") forceActive: boolean;

  _data: Array<any>;
  filteredData: Array<any>;
  selected: Array<boolean>;
  activeSelection: boolean;
  @Input()
  set data(data: Array<any>) {
    this.activeSelection = false;
    if (!data) {
      return;
    }
    this._data = data;
    this.filteredData = this._data;
    this.selected = new Array(data.length);
    this.selected.fill(false);
  }

  @Input("disabled") disabled: boolean;
  @Input("singleItemSelection") singleItemSelection: boolean;

  @Output() add: EventEmitter<any>;

  showDropdown: boolean;
  inputFilter: string;

  constructor() {
    this.add = new EventEmitter();
    this.showDropdown = false;
  }

  async doEmit() {
    const toEmit = [];
    for (let i = 0; i < this.selected.length; i++) {
      if (this.selected[i]) {
        toEmit.push(this.filteredData[i]);
      }
    }
    this.add.emit(toEmit);
    this.doHideDropdown();
    await Utils.sleep(25);
    this.showDropdown = false;
  }

  async itemSelected(i: number) {
    if (this.singleItemSelection) {
      const placeholderName = this.filteredData[i].name;
      this.add.emit(this.filteredData[i]);
      this.doHideDropdown();
      await Utils.sleep(25);
      this.showDropdown = false;
      this.inputFilter = placeholderName;
    } else {
      this.selected[i] = !this.selected[i];
      this.activeSelection = false;
      for (let j = 0; j < this.selected.length; j++) {
        if (this.selected[j]) {
          this.activeSelection = true;
        }
      }
    }
  }

  // visuals management
  async doShowDropdown() {
    if (this.showDropdown) {
      return;
    }
    await Utils.sleep();
    this.showDropdown = true;
  }
  doHideDropdown(e?) {
    if (
      (e && e.srcElement.id.indexOf("mat-input") >= 0) ||
      !this.showDropdown
    ) {
      // don't hide if they're clicking the input bar
      return;
    }
    this.showDropdown = false;
    this.selected = [];
    this.filterResults("");
    this.activeSelection = false;
  }

  filterResults(newFilter) {
    this.inputFilter = newFilter;
    this.filteredData = [];
    if (this._data) {
      this._data.forEach((datum) => {
        if (
          datum.name.toLowerCase().indexOf(this.inputFilter.toLowerCase()) >= 0
        ) {
          this.filteredData.push(datum);
        }
      });
    }
    this.selected = new Array(this.filteredData.length);
    this.selected.fill(false);
  }

  public clearFilter() {
    this.inputFilter = null;
  }

  reset() {
    this.showDropdown = false;
    this.selected = [];
    this.filterResults("");
    this.activeSelection = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dropdown/dropdown.component.ts